import Layout from "../components/layout/Layout";
import OnboardingMessageList from "../components/page/OnboardingMessageList";

const OnboardingMessageListPage = () => {
  return (
    <Layout>
      <OnboardingMessageList />
    </Layout>
  );
};
export default OnboardingMessageListPage;
